/**
 * 存储Storage
 */
export const setStore = (params = {}) => {
  let { name, content } = params;
  const obj = {
    content: content,
    datetime: Date.now(),
  }
  try {
    localStorage.setItem(name, JSON.stringify(obj));
  } catch (e) {
    console.log(e);
  }
}
/**
 * 获取localStorage
 */

export const getStore = (params = {}) => {
  let { name } = params
  let obj = {}
  try {
    obj = localStorage.getItem(name);

  } catch (e) {
    console.log(e);
  }
  let content = ''
  try {
    obj = obj ? JSON.parse(obj) : null
    content = obj.content || null
  } catch (e) {
    return obj
  }
  return content
}
/**
 * 删除localStorage
 */
export const removeStore = (params = {}) => {
  let { name } = params;
  try {
    localStorage.removeItem(name);
  } catch (e) {
    console.error(e)
  }
}

/**
 * 清空全部localStorage
 */
export const clearStore = (params = {}) => {
  try {
    localStorage.clear();
  } catch (e) {
    console.error(e);
  }
}
